import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  mode: 'light',
  palette: {
    primary: {
      main: '#262626',
      contrastText: '#fff',
    },
    secondary: {
      main: '#e86c30',
      contrastText: '#fff',
    },
    white: {
      main: '#ffffff',
      contrastText: '#262626',
    },
    error: {
      main: '#dd4952',
    },
    warning: {
      main: '#ffa726',
    },
    info: {
      main: '#a4a4a4',
      contrastText: '#fff',
    },
    success: {
      main: '#66bb6a',
    },
    red: {
      main: '#FF3B30',
    },
    blue: {
      main: '#2670D1',
      contrastText: '#fff',
    },
    green: {
      main: '#00D32A',
      contrastText: '#fff',
    },
    orange: {
      main: '#FF9500',
      contrastText: '#fff',
    },
    purple: {
      main: '#7B44F2',
      contrastText: '#fff',
    },
    cian: {
      main: '#56F2F7',
      contrastText: '#fff',
    },
    status: {
      red: '#FF1E00',
      orange: '#FF9500',
      green: '#00D32A',
      blue: '#2670D1',
      ciano: '#56F2F7',
      trained: 'rgba(52, 199, 89, 0.1)',
      purple: '#7B44F2',
      gradient:
        'linear-gradient(90deg, #56F2F7 0%, #2670D1 33%, #7B44F2 66%, #AE4A96 100%)',
      yellow: '#ddc807',
    },
    gradient: {
      primary:
        'linear-gradient(90deg, #56F2F7 0%, #2670D1 33%, #7B44F2 66%, #AE4A96 100%)',
      secondary:
        'linear-gradient(180deg, rgba(86, 242, 247, 0.8) 0%, rgba(38, 112, 209, 0.8) 33%, rgba(123, 68, 242, 0.8) 66%, rgba(174, 74, 150, 0.8) 100%)',
    },
    lightgrey: {
      main: '#F2F2F2',
    },
    colors: {
      white: '#ffffff',
      black: '#000000',
      grey: '#4C4C4C',
      backgroundgrey: '#F7F7F7',
      light: 'rgba(0, 0, 0, 0.10)',
      lightgrey: '#A4A4A4',
      background: '#999999',
      shadow: 'rgba(0,0,0,.16)',
      lightshadow: 'rgba(112,112,112,.06)',
      required: '#7B44F2',
      //required:'rgba(227, 68, 6, 0.89)'
    },
    botao: {
      main: '#66bb6a',
      contrastText: '#fff',
    },
  },
});
